export default "{\n    \"label\": \"{{name}}\",\n    \"label_0\": \"Categoría\",\n    \"label_plural\": \"{{count}} categorías\"\n}\n"